<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ToggleInfoChip from '@/components/dike/ToggleInfoChip.vue'

defineOptions({ name: 'DikeTrajectoryToggleChips' })

const store = useStore()

const showOverview = computed(() => store.state.dikeProfiles.showOverview)
const showList = computed(() => store.state.stabSchematisation.showList)

const toggleShowOverview = (val) => store.dispatch('dikeProfiles/toggleShowOverview', val)

const toggleShowList = (val) => store.dispatch('stabSchematisation/toggleShowList', val)
</script>

<template>
  <div class="chips-container fill-height my-auto">
    <ToggleInfoChip
      :bool="showList"
      chip-text="List view"
      text="Display flattened schematisation list or dike section index"
      @toggle="toggleShowList(!showList)"
    />
    <ToggleInfoChip
      :bool="showOverview"
      chip-text="Overview"
      text="Toggle schematisation overview drawer to show schematisation done stages"
      @toggle="toggleShowOverview(!showOverview)"
    />
    </div>
</template>
<style scoped>
.chips-container {
  display: flex;
  gap: 6px;
}
</style>
